import React, {VoidFunctionComponent} from "react";


interface Props {
    title: string;
    onClick: () => void;
    children?: JSX.Element;
    isClickable?: boolean,
    id: string;
    className?: string;
}

export const CategoryBlock: VoidFunctionComponent<Props> = ({title, onClick, children, isClickable = true, id, className = ""}) => {
    return (
        <div className={`category-block ${className} ${isClickable ? 'clickable' : null} `} id={id} onClick={isClickable ? onClick : undefined}>
            <div className={`content`}>
                <div className='title'>{title}</div>
                {children}
            </div>
            {isClickable && <img src={'/assets/images/responsive/icons/arrow.svg'} alt='bouton flèche'/>}
        </div>
    );
};